import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from '@grebban/style-system-react';
import Text from 'components/Text';
// import useAppDispatch from '@fogia/core-web/hooks/useAppDispatch';
// import { show as showOverlay, close as closeOverlay } from '@fogia/core-web/state/application/overlay';
import { above } from '@fogia/core-web/utils/mediaqueries';
import useBreakpoint from '@fogia/core-web/hooks/useBreakpoint';
import CategoryFilterButtons from './CategoryFilterButtons';
// import BoxButton from 'components/BoxButton';
// import ToggleFilter from './ToggleFilter';

const BaseWrapper = styled('div')`
    width: 100%;
    z-index: 3;
    position: sticky;
    pointer-events: none;
    padding: 16px 12px;
    border-bottom: 1px solid var(--color-neutrals-200);
    &[data-is-pinned='true'] {
        padding: 0;
    }

    ${above['desktop.sm']} {
        padding: 16px 0;
    }
`;

const DesktopWrapper = styled(BaseWrapper)`
    border-top: 1px solid var(--color-neutrals-200);

    ${above['desktop.sm']} {
        padding: 10px 0;
        margin-bottom: 16px;
    }
`;

const MobileWrapper = styled(BaseWrapper)`
    display: flex;
    justify-content: flex-end;
`;

const Row = styled('div')`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const NumberOfProducts = styled(Text)`
    color: var(--opacity-primary-50);
    pointer-events: initial;
    white-space: nowrap;
`;

const StickyTop = styled('div')`
    height: 1px;
`;

const FilterBar = ({
    filters,
    // scrollToTop,
    // config,
    hasCategoryFilter,
    selectedFilters,
    // clear,
    // setFilterVisible,
    // filterState,
    // shouldScrollState,
    // filterOverlayData,
    // handleChange,
    hitsCount,
    // sorts,
}) => {
    const { t } = useTranslation();
    // const dispatch = useAppDispatch();
    const isMobile = useBreakpoint({ to: 'desktop.sm' });
    // const [isClosedFilterMobileMenu, setIsClosedFilterMobileMenu] = useState(false);

    // const displayFilter = () => {
    //     const closeFilter = () => {
    //         dispatch(closeOverlay());
    //         setIsClosedFilterMobileMenu(true);
    //     };

    //     const overlayData = {
    //         filters,
    //         scrollToTop,
    //         handleChange: handleChange.filter,
    //         config,
    //         hasCategoryFilter,
    //         selectedFilters,
    //         clear,
    //         setFilterVisible,
    //         hitsCount,
    //         closeFilter,
    //     };

    //     if (isMobile) {
    //         dispatch(showOverlay({ view: 'filterOverlay', transition: 'from-left', data: overlayData }));
    //     }
    // };

    // const displaySort = () => {
    //     dispatch(
    //         showOverlay({
    //             view: 'sortProductGridOverlay',
    //             transition: 'from-right',
    //             data: {
    //                 sorts,
    //                 handleChange: handleChange.sort,
    //             },
    //         }),
    //     );
    // };

    return (
        <>
            <StickyTop />
            <DesktopWrapper>
                <Row>
                    {/* <ToggleFilter
                        disableHover
                        pointerEvents="initial"
                        filterState={filterState}
                        shouldScrollState={shouldScrollState}
                        filterOverlayData={filterOverlayData}
                        displayFilter={displayFilter}
                        isClosedFilterMobileMenu={isClosedFilterMobileMenu}
                    /> */}
                    <CategoryFilterButtons
                        filters={filters}
                        selectedFilters={selectedFilters}
                        hasCategoryFilter={hasCategoryFilter}
                    />
                    {!isMobile && !!hitsCount && (
                        <NumberOfProducts typography="Primary/15_120_510_-1">
                            {t('category.filter.number_of_products_displayed', { count: hitsCount })}
                        </NumberOfProducts>
                    )}
                    {/* <BoxButton disableHover size="large" pointerEvents="initial" onClick={displaySort}>
                        <Text typography="Primary/15_120_510_-1">{t('filter.sort')}</Text>
                    </BoxButton> */}
                </Row>
            </DesktopWrapper>
            {isMobile && !!hitsCount && (
                <MobileWrapper>
                    <Row>
                        <NumberOfProducts typography="Primary/15_120_510_-1">
                            {t('category.filter.number_of_products_displayed', { count: hitsCount })}
                        </NumberOfProducts>
                    </Row>
                </MobileWrapper>
            )}
        </>
    );
};

FilterBar.propTypes = {
    filterOverlayData: PropTypes.shape({
        clear: PropTypes.object,
        config: PropTypes.object,
        filters: PropTypes.array,
        handleChange: PropTypes.object,
        hasCategoryFilter: PropTypes.bool,
        hitsCount: PropTypes.number,
        scrollToTop: PropTypes.func,
        searchOpen: PropTypes.bool,
        selectedFilters: PropTypes.array,
    }).isRequired,
    filterState: PropTypes.array.isRequired,
    handleChange: PropTypes.shape({
        filter: PropTypes.shape({
            value: PropTypes.func,
            range: PropTypes.func,
        }),
        sort: PropTypes.func,
    }).isRequired,
    hitsCount: PropTypes.number,
    shouldScrollState: PropTypes.array.isRequired,
    scrollToTop: PropTypes.func,
    sorts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    filterButtons: PropTypes.array,
    clear: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
};

FilterBar.defaultProps = {
    hitsCount: undefined,
    scrollToTop: () => {},
    filterButtons: [],
    isMobile: false,
};

export default withRouter(FilterBar);
